module.exports = __webpack_public_path__ + "img/logo_2024_blue_german.1b00088e.svg";